export default "__VITE_ASSET__854c2dbd__"